// extracted by mini-css-extract-plugin
export default {"watch":"Watch_watch__ODkSH"};